export const ERS_NUMBERS = 'E140814/E185032';
export const ERS_LABEL = `ERS n.º ${ERS_NUMBERS}`;
export const withErs = (name) => (/Ana Magalhães Pereira/i.test(name || '') ? `${name} · ${ERS_LABEL}` : name);
